export default __webpack_public_path__ + "static/media/Stamp6.0aaeb4e1.svg";